<template>
  <ul class="mt-2 text-xs" v-if="password">
    <li
      v-for="rule in rules"
      :key="rule.key"
      class="flex items-center py-1"
      :class="rule.ok ? 'text-emerald-500' : 'text-blueGray-500'"
    >
      <i
        class="mr-2 fas"
        :class="rule.ok ? 'fa-check' : 'fa-xmark'"
        aria-hidden="true"
      ></i>
      {{ $t(rule.label) }}
    </li>
  </ul>
</template>
<script>
import { checkPassword } from "@/utils/passwordPolicy";

export default {
  props: {
    password: {
      type: String,
      default: "",
    },
    // { nombre, mail } del usuario, para bloquear contraseñas derivadas de sus
    // datos personales
    context: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    rules() {
      return checkPassword(this.password || "", this.context || {});
    },
  },
};
</script>
